import store from '../store';

const adminRoutes = [
	{ 
		path: '/admin/asset-types', 
		name: 'admin.asset_types',
		component: require('../pages/admin/AssetTypesIndex.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/specialties', 
		name: 'admin.specialties',
		component: require('../pages/admin/SpecialtiesIndex.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything || perms.can_administer_specialties) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/specialties/mappings', 
		name: 'admin.specialties.mappings',
		component: require('../pages/admin/SpecialtiesMappings.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything || perms.can_administer_specialties) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},

	{ 
		path: '/admin/service-lines', 
		name: 'admin.service_lines',
		component: require('../pages/admin/ServiceLinesIndex.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/front-promos', 
		name: 'admin.front_promos',
		component: require('../pages/admin/FrontPromosIndex.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},


	{ 
		path: '/admin/trashed/campaigns', 
		name: 'admin.trashed.campaigns',
		component: require('../pages/admin/trashed/Campaigns.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/trashed/checkins', 
		name: 'admin.trashed.checkins',
		component: require('../pages/admin/trashed/Checkins.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/trashed/goals', 
		name: 'admin.trashed.goals',
		component: require('../pages/admin/trashed/Goals.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/trashed/groups', 
		name: 'admin.trashed.groups',
		component: require('../pages/admin/trashed/Groups.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/trashed/notes', 
		name: 'admin.trashed.notes',
		component: require('../pages/admin/trashed/Notes.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/trashed/physicians', 
		name: 'admin.trashed.physicians',
		component: require('../pages/admin/trashed/Physicians.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/trashed/routes', 
		name: 'admin.trashed.routes',
		component: require('../pages/admin/trashed/Routes.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},
	{ 
		path: '/admin/trashed/tasks', 
		name: 'admin.trashed.tasks',
		component: require('../pages/admin/trashed/Tasks.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},

	{
		path: '/roles',
		name: 'roles.index',
		component: require('../pages/users/RolesIndex.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}			
		}
	},

	{
		path: '/permissions',
		name: 'permissions.index',
		component: require('../pages/users/PermissionsIndex.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_do_everything) {
					next();
				} else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}			
		}
	},
	
];

export default adminRoutes;